/**
 * One scroll lock for the menu, search, filter drawer, condition sheet, and Your Cart.
 * A count so closing one layer does not unlock the page while another is open.
 *
 * The page stays where it is. Pinning the body and shifting it up by the scroll distance made an iPhone bring
 * its toolbar back and move the header while the menu or keyboard was opening, so a layer opened after scrolling
 * down stuttered and its contents were measured in the wrong place. Body overflow (never html: that would make
 * the body its own scroller and drop the sticky header off screen) stops the page; a touch guard does the same
 * where Safari ignores it, and still lets a menu, list, or chip row scroll.
 */
(function () {
  var count = 0;
  var y = 0;
  var lastX = 0;
  var lastY = 0;

  function clearStyles() {
    document.body.style.overflow = '';
    document.documentElement.style.overscrollBehavior = '';
  }

  function lock() {
    if (count === 0) {
      y = window.scrollY || window.pageYOffset || 0;
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overscrollBehavior = 'none';
    }
    count += 1;
  }

  function unlock() {
    if (count === 0) return;
    count -= 1;
    if (count > 0) return;
    clearStyles();
    /* An iPhone can still move the page itself while a field has focus. Put it back where it was. */
    var now = window.scrollY || window.pageYOffset || 0;
    if (Math.abs(now - y) > 1) window.scrollTo(0, y);
  }

  /* True when something under the finger can still scroll the way the finger is moving. */
  function scrollsAlong(node, dx, dy) {
    var sideways = Math.abs(dx) > Math.abs(dy);
    for (; node && node !== document.body && node !== document.documentElement; node = node.parentNode) {
      if (node.nodeType !== 1) continue;
      var style = window.getComputedStyle(node);
      if (sideways) {
        if (!/(auto|scroll)/.test(style.overflowX) || node.scrollWidth <= node.clientWidth + 1) continue;
        if (dx > 0 ? node.scrollLeft > 0 : node.scrollLeft + node.clientWidth < node.scrollWidth - 1) return true;
      } else {
        if (!/(auto|scroll)/.test(style.overflowY) || node.scrollHeight <= node.clientHeight + 1) continue;
        if (dy > 0 ? node.scrollTop > 0 : node.scrollTop + node.clientHeight < node.scrollHeight - 1) return true;
      }
    }
    return false;
  }

  document.addEventListener('touchstart', function (event) {
    if (event.touches.length !== 1) return;
    lastX = event.touches[0].clientX;
    lastY = event.touches[0].clientY;
  }, { passive: true });

  document.addEventListener('touchmove', function (event) {
    /* Two fingers is a pinch zoom; leave it alone. */
    if (count === 0 || event.touches.length !== 1 || !event.cancelable) return;
    var touch = event.touches[0];
    var dx = touch.clientX - lastX;
    var dy = touch.clientY - lastY;
    lastX = touch.clientX;
    lastY = touch.clientY;
    if (!dx && !dy) return;
    if (!scrollsAlong(event.target, dx, dy)) event.preventDefault();
  }, { passive: false });

  function reset() {
    count = 0;
    y = 0;
    clearStyles();
    document.documentElement.classList.remove('ri-sheet-open', 'ri-search-open');
    document.querySelectorAll('header-drawer details[open], menu-drawer details[open]').forEach(function (details) {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    document.querySelectorAll('ri-choose-options.is-sheet').forEach(function (sheet) {
      sheet.classList.remove('is-open', 'is-sheet');
      sheet.hidden = true;
    });
    var cart = document.getElementById('RiAddedPanel');
    if (cart) {
      cart.classList.remove('is-open');
      cart.hidden = true;
    }
  }

  window.RIScrollLock = { lock: lock, unlock: unlock, reset: reset };

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) reset();
  });
})();
